export interface Maintenance {
  id?: string;
  date_from: string;
  date_to: string;
  is_disabled: boolean;
  content: string;
  type: MaintenanceType;
}

export enum MaintenanceType {
  CLIENT_PORTAL = 'client_portal',
  PORTAL = 'portal',
}
